import { makeStyles } from '@mui/styles';
import React, { useState, useEffect, useCallback } from 'react';
import { Page, Header, Alert } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import { Grid, Button, Card, CardContent, CardHeader, Divider } from '@mui/material';

import NominationPDFForm from './components/NominationPDFForm';
import NominationPDFTable from './components/NominationPDFTable';
import GetLastResult from '../actions/NominationFormActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
}));

const NominationForm = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	// const lastResult = useSelector((state) => state.nominationFormReducer.lastResult);

	/* useEffect(() => {
		dispatch(GetLastResult());
	}, []); */

	return (
		<Page className={classes.root} title="Nomination Form">
			<Header
				module="Menu"
				view="Nomination Form"
			/>
			<Alert
				className={classes.container}
				variant="info"
				// message={_.isUndefined(lastResult) ? 'Last Result date is unavailable!' : lastResult}
			/>
			<Card className={classes.container} container spacing={3}>
				<CardHeader title="File Uploader & PDF Generation" />
				<Divider />
				<CardContent>
					<div>* Input Excel File with 2 columns 'Sample Cell Name' and 'Type' (CR or SSR)</div>
					<NominationPDFForm className={classes.results} />
					<Divider />
					<Grid container spacing={3}>
						<Grid item lg={12} xs={12}>
							<Button
								className={classes.agreeButton}
								color="success"
								variant="contained"
								size="medium"
							>
								Generate PDF(s)
							</Button>
							<Button
								className={classes.agreeButton}
								color="primary"
								variant="contained"
								size="medium"
							>
								Refresh
							</Button>
						</Grid>
					</Grid>
				</CardContent>
			</Card>
			<Card className={classes.container} container spacing={3}>
				<CardHeader title="Last Result" />
				<Divider />
				<CardContent>
					<Grid container spacing={2}>
						<Grid item lg={12} xs={12}>
							<NominationPDFTable className={classes.results} />
						</Grid>
					</Grid>
				</CardContent>
			</Card>
		</Page>
	);
};

export default NominationForm;
